import React from 'react';
import { message } from 'antd';
import { CardProps as AntdCardProps } from 'antd/lib/card';
import './index.style.less';
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import { CKEditor as MyEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

export interface CardProps extends AntdCardProps {
  data?: string;
  readonly?: boolean;
  className?: string;
  onSetData?: (data) => void;
}

const uploadAdapter = (loader) => {
  return {    
    upload: () => {
      return new Promise((resolve, reject) => {
        const body = new FormData();
        loader.file.then((file) => {
          body.append("files", file); 

          axios({
            url: SERVER_URL + endpoints.file.uploadImage,
            method: 'post',
            data: body,
          })
            .then((response) => {
              resolve({
                default: SERVER_URL + response.data.url
              });
            })
            .catch((err) => {
              reject(err);
              message.error('파일 업로드 중 에러가 발생했습니다.');
            });   
        });          
      });
    }
  }
}

const ckEditorConfig = {
  fontSize: {
    options: [
      '8px', 
      '9px', 
      '10px', 
      '11px', 
      '12px', 
      '13px', 
      'default', 
      '15px', 
      '16px', 
      '18px', 
      '20px', 
      '22px', 
      '24px', 
      '26px', 
      '28px', 
      '36px', 
      '48px', 
      '60px', 
      '72px'
    ],
    supportAllValues: true,
  },
  fontFamily: {
    options: [
      'default', 
      '맑은고딕',
      '나눔바른고딕', 
      '나눔고딕', 
      '굴림', 
      '돋음', 
      '바탕', 
      '궁서',
      'Arial', 
      'Comic Sans Ms', 
      'Courier New', 
      'Georgia', 
      'Tahoma', 
      'Times New Roman', 
      'Verdana' 
    ],
    supportAllValues: true,
  }, 
  image: {
    resizeUnit: "%",
    resizeOptions: [ {
      name: 'resizeImage:original',
      value: null,
      icon: 'original'
    },
    {
      name: 'resizeImage:25',
      value: '25',
      icon: 'small'
    },    
    {
      name: 'resizeImage:50',
      value: '50',
      icon: 'medium'
    },
    {
      name: 'resizeImage:75',
      value: '75',
      icon: 'large'
    } ],
    styles: {
      options : [
      { name: 'alignBlockLeft', isDefault: true },
      { name: 'block', className: 'image-style-block-align-center', isDefault: false },
      { name: 'alignBlockRight', className: 'image-style-block-align-right', isDefault: false }
	    ,'inline', 'alignLeft', 'alignRight'
      ],
    },
    toolbar: [
      'imageStyle:inline', 
      'imageStyle:alignLeft', 
      'imageStyle:alignRight', 
      '|', 
      'imageStyle:alignBlockLeft', 
      'imageStyle:block', 
      'imageStyle:alignBlockRight', 
      '|', 
      'toggleImageCaption', 
      'linkImage', 
      '|', 
      'resizeImage'],
  }, 
	table: {
		// ...other "table" options.
		tableProperties: {
			defaultProperties: {
				alignment: 'left',
				borderColor: '#b3b3b3',
				borderWidth: '1px',
				borderStyle: 'double'
			}
		},
    tableCellProperties: {
			defaultProperties: {
				borderColor: '#bfbfbf',
				borderWidth: '1px',
				borderStyle: 'solid'
			}
		}
	},
  toolbar: {
    removeItems: ["specialCharacters", "mediaEmbed"]
  },
}  

const CKEditor = ({
  data,
  className,
  readonly,
  onSetData,
  ...rest
}: React.PropsWithChildren<CardProps>): React.ReactElement => {

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={className}>
      <MyEditor
        config={ckEditorConfig}                    
        data={data?data:''}
        editor={Editor}
        disabled={readonly}
        onChange={(event, editor) => {
          const data = editor.getData();
          if (onSetData) onSetData(data);
        }}
        onReady={editor => {
          if (!readonly) {
            window.editor = editor;
            editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
              return uploadAdapter(loader);
            };              
          } 
        }}
      ></MyEditor>
    </div>
  );
};

export default CKEditor;
